import { Suspense, lazy, useState } from 'react';

import { useTranslation } from 'react-i18next';

import Button from '@/components/Button';
import Spinner from '@/components/Spinner';
import ContactUsIcon from '@/icons/contact-us.svg';

const Form = lazy(() => import('./Form'));

function Contact() {
	const { t } = useTranslation();
	const [success, setSuccess] = useState(false);

	return (
		<main className="relative flex flex-col items-center justify-center bg-grey-100 pb-10 pt-7 lg:pb-[140px] lg:pt-[80px]">
			<div className="mb-8 lg:mb-20 lg:text-center">
				<div className="container flex flex-col gap-3 lg:gap-5">
					<h1 className="font-title text-[32px] font-bold leading-10 lg:text-[56px] lg:leading-[64px]">
						{t('contact.main.title')}
					</h1>
					<h2 className="max-w-[814px] text-sm lg:text-base">
						{t('contact.main.subtitle')}
					</h2>
				</div>
			</div>

			<div className="container lg:px-[106px]">
				<section className="relative flex items-center justify-center rounded-xl border border-grey-200 bg-white shadow-lg">
					<div className="flex min-h-[307px] w-full flex-col items-center justify-center gap-10 px-4 py-6 lg:px-7 lg:py-12">
						{success ? (
							<div className="flex flex-col items-center gap-6">
								<ContactUsIcon />
								<div className="flex flex-col items-center gap-2">
									<h3 className="text-center text-xl font-semibold lg:leading-8">
										{t('contact.form.fullfilled.title')}
									</h3>
									<p className="text-center leading-7 text-grey-500">
										{t('contact.form.fullfilled.description')}
									</p>
								</div>

								<Button
									variant="outline"
									onClick={() => {
										setSuccess(false);
									}}
									className="w-[134px] self-center px-6 py-3"
								>
									{t('contact.form.back')}
								</Button>
							</div>
						) : (
							<Suspense
								fallback={
									<Spinner size={50} className="mb-auto mt-20" />
								}
							>
								<Form onSuccess={() => setSuccess(true)} />
							</Suspense>
						)}
					</div>
				</section>
			</div>
		</main>
	);
}
export default Contact;
